/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineBookingRoomStayRsDto } from './traveline-booking-room-stay-rs-dto';
import {
    TravelineBookingRoomStayRsDtoFromJSON,
    TravelineBookingRoomStayRsDtoFromJSONTyped,
    TravelineBookingRoomStayRsDtoToJSON,
    TravelineBookingRoomStayRsDtoToJSONTyped,
} from './traveline-booking-room-stay-rs-dto';
import type { TravelineBookingCancellationDto } from './traveline-booking-cancellation-dto';
import {
    TravelineBookingCancellationDtoFromJSON,
    TravelineBookingCancellationDtoFromJSONTyped,
    TravelineBookingCancellationDtoToJSON,
    TravelineBookingCancellationDtoToJSONTyped,
} from './traveline-booking-cancellation-dto';
import type { TravelineBookingPrepaymentDto } from './traveline-booking-prepayment-dto';
import {
    TravelineBookingPrepaymentDtoFromJSON,
    TravelineBookingPrepaymentDtoFromJSONTyped,
    TravelineBookingPrepaymentDtoToJSON,
    TravelineBookingPrepaymentDtoToJSONTyped,
} from './traveline-booking-prepayment-dto';
import type { TravelineCancellationPolicyDto } from './traveline-cancellation-policy-dto';
import {
    TravelineCancellationPolicyDtoFromJSON,
    TravelineCancellationPolicyDtoFromJSONTyped,
    TravelineCancellationPolicyDtoToJSON,
    TravelineCancellationPolicyDtoToJSONTyped,
} from './traveline-cancellation-policy-dto';
import type { TravelineBookingTaxDto } from './traveline-booking-tax-dto';
import {
    TravelineBookingTaxDtoFromJSON,
    TravelineBookingTaxDtoFromJSONTyped,
    TravelineBookingTaxDtoToJSON,
    TravelineBookingTaxDtoToJSONTyped,
} from './traveline-booking-tax-dto';
import type { TravelineBookingServiceRsDto } from './traveline-booking-service-rs-dto';
import {
    TravelineBookingServiceRsDtoFromJSON,
    TravelineBookingServiceRsDtoFromJSONTyped,
    TravelineBookingServiceRsDtoToJSON,
    TravelineBookingServiceRsDtoToJSONTyped,
} from './traveline-booking-service-rs-dto';
import type { TravelineBookingTotalDto } from './traveline-booking-total-dto';
import {
    TravelineBookingTotalDtoFromJSON,
    TravelineBookingTotalDtoFromJSONTyped,
    TravelineBookingTotalDtoToJSON,
    TravelineBookingTotalDtoToJSONTyped,
} from './traveline-booking-total-dto';
import type { TravelineBookingCustomerDto } from './traveline-booking-customer-dto';
import {
    TravelineBookingCustomerDtoFromJSON,
    TravelineBookingCustomerDtoFromJSONTyped,
    TravelineBookingCustomerDtoToJSON,
    TravelineBookingCustomerDtoToJSONTyped,
} from './traveline-booking-customer-dto';

/**
 * 
 * @export
 * @interface TravelineVerifyBookingRsDto
 */
export interface TravelineVerifyBookingRsDto {
    /**
     * Property ID
     * @type {string}
     * @memberof TravelineVerifyBookingRsDto
     */
    propertyId: string;
    /**
     * List of stays
     * @type {Array<TravelineBookingRoomStayRsDto>}
     * @memberof TravelineVerifyBookingRsDto
     */
    roomStays: Array<TravelineBookingRoomStayRsDto>;
    /**
     * Extra services<br />
     * Services with a payment type ’Per Booking’ (ChargeType = PerReservation) are available here
     * @type {Array<TravelineBookingServiceRsDto>}
     * @memberof TravelineVerifyBookingRsDto
     */
    services?: Array<TravelineBookingServiceRsDto> | null;
    /**
     * 
     * @type {TravelineBookingCustomerDto}
     * @memberof TravelineVerifyBookingRsDto
     */
    customer: TravelineBookingCustomerDto;
    /**
     * 
     * @type {TravelineBookingPrepaymentDto}
     * @memberof TravelineVerifyBookingRsDto
     */
    prepayment?: TravelineBookingPrepaymentDto;
    /**
     * Agent comments on the booking<br />
     * Maximum number of comments: 5 по 250 characters
     * @type {Array<string>}
     * @memberof TravelineVerifyBookingRsDto
     */
    bookingComments?: Array<string> | null;
    /**
     * 
     * @type {TravelineBookingTotalDto}
     * @memberof TravelineVerifyBookingRsDto
     */
    total: TravelineBookingTotalDto;
    /**
     * Taxes and fees
     * @type {Array<TravelineBookingTaxDto>}
     * @memberof TravelineVerifyBookingRsDto
     */
    taxes: Array<TravelineBookingTaxDto>;
    /**
     * Booking currency
     * @type {string}
     * @memberof TravelineVerifyBookingRsDto
     */
    currencyCode?: string | null;
    /**
     * 
     * @type {TravelineBookingCancellationDto}
     * @memberof TravelineVerifyBookingRsDto
     */
    cancellation: TravelineBookingCancellationDto;
    /**
     * 
     * @type {TravelineCancellationPolicyDto}
     * @memberof TravelineVerifyBookingRsDto
     */
    cancellationPolicy: TravelineCancellationPolicyDto;
    /**
     * Token for creating booking<br />
     * Used in method "Create booking"
     * @type {string}
     * @memberof TravelineVerifyBookingRsDto
     */
    createBookingToken: string;
}

/**
 * Check if a given object implements the TravelineVerifyBookingRsDto interface.
 */
export function instanceOfTravelineVerifyBookingRsDto(value: object): value is TravelineVerifyBookingRsDto {
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    if (!('roomStays' in value) || value['roomStays'] === undefined) return false;
    if (!('customer' in value) || value['customer'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('taxes' in value) || value['taxes'] === undefined) return false;
    if (!('cancellation' in value) || value['cancellation'] === undefined) return false;
    if (!('cancellationPolicy' in value) || value['cancellationPolicy'] === undefined) return false;
    if (!('createBookingToken' in value) || value['createBookingToken'] === undefined) return false;
    return true;
}

export function TravelineVerifyBookingRsDtoFromJSON(json: any): TravelineVerifyBookingRsDto {
    return TravelineVerifyBookingRsDtoFromJSONTyped(json, false);
}

export function TravelineVerifyBookingRsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineVerifyBookingRsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'propertyId': json['propertyId'],
        'roomStays': ((json['roomStays'] as Array<any>).map(TravelineBookingRoomStayRsDtoFromJSON)),
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(TravelineBookingServiceRsDtoFromJSON)),
        'customer': TravelineBookingCustomerDtoFromJSON(json['customer']),
        'prepayment': json['prepayment'] == null ? undefined : TravelineBookingPrepaymentDtoFromJSON(json['prepayment']),
        'bookingComments': json['bookingComments'] == null ? undefined : json['bookingComments'],
        'total': TravelineBookingTotalDtoFromJSON(json['total']),
        'taxes': ((json['taxes'] as Array<any>).map(TravelineBookingTaxDtoFromJSON)),
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'cancellation': TravelineBookingCancellationDtoFromJSON(json['cancellation']),
        'cancellationPolicy': TravelineCancellationPolicyDtoFromJSON(json['cancellationPolicy']),
        'createBookingToken': json['createBookingToken'],
    };
}

  export function TravelineVerifyBookingRsDtoToJSON(json: any): TravelineVerifyBookingRsDto {
      return TravelineVerifyBookingRsDtoToJSONTyped(json, false);
  }

  export function TravelineVerifyBookingRsDtoToJSONTyped(value?: TravelineVerifyBookingRsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'propertyId': value['propertyId'],
        'roomStays': ((value['roomStays'] as Array<any>).map(TravelineBookingRoomStayRsDtoToJSON)),
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(TravelineBookingServiceRsDtoToJSON)),
        'customer': TravelineBookingCustomerDtoToJSON(value['customer']),
        'prepayment': TravelineBookingPrepaymentDtoToJSON(value['prepayment']),
        'bookingComments': value['bookingComments'],
        'total': TravelineBookingTotalDtoToJSON(value['total']),
        'taxes': ((value['taxes'] as Array<any>).map(TravelineBookingTaxDtoToJSON)),
        'currencyCode': value['currencyCode'],
        'cancellation': TravelineBookingCancellationDtoToJSON(value['cancellation']),
        'cancellationPolicy': TravelineCancellationPolicyDtoToJSON(value['cancellationPolicy']),
        'createBookingToken': value['createBookingToken'],
    };
}

